import React, { useContext } from 'react';
import { string, number, bool } from 'prop-types';
import { translate, Trans } from 'react-i18next';
import classnames from 'classnames/bind';

import ContextStore from '@dragonfruit/services/createContext.js';

import { quotaParser } from '@dragonfruit/utils/quotaParser';
import { formatPriceNumber } from '@dragonfruit/utils/priceParser';

import styles from './Token.scss';
const cx = classnames.bind(styles);

function Token({
  name,
  description,
  highlight,
  quota,
  currency,
  displayCurrency,
  price,
  paymentMethodId,
  isMiniClass,
}) {
  const { goToPurchasePage } = useContext(ContextStore);

  const handleGoToPurchase = () => goToPurchasePage(paymentMethodId);

  const timeTypeUnit = quotaNumber =>
    quotaNumber <= 1
      ? 'premium.quotaUnit.timeWithCount'
      : 'premium.quotaUnit.timeWithCount_plural';

  const qaTypeUnit = quotaNumber =>
    quotaNumber <= 1
      ? 'premium.quotaUnit.qaWithCount'
      : 'premium.quotaUnit.qaWithCount_plural';

  const quotaUnitI18nKey = isMiniClass
    ? timeTypeUnit(quota)
    : qaTypeUnit(quota);

  return (
    <div
      className={cx(styles.root, {
        miniClass: isMiniClass,
        highlight,
      })}
      onClick={handleGoToPurchase}
    >
      {highlight && <h6 className={styles.label}>{highlight}</h6>}
      <div className={styles.content}>
        <h3 className={styles.name}>{name}</h3>
        <p className={styles.description}>{description}</p>
        <h4 className={styles.price}>
          <Trans i18nKey="premium.priceDisplayFormat">
            Price
            <div className={styles.symbol}>{{ symbol: displayCurrency }}</div>
            <div>{{ number: formatPriceNumber(currency, price) }}</div>
          </Trans>
        </h4>
        <div className={styles.quota}>
          <Trans i18nKey={quotaUnitI18nKey} count={quota}>
            Quota
            <div className={styles.number}>{{ count: quotaParser(quota) }}</div>
          </Trans>
        </div>
      </div>
    </div>
  );
}

Token.propTypes = {
  currency: string.isRequired,
  displayCurrency: string.isRequired,
  name: string.isRequired,
  paymentMethodId: number.isRequired,
  price: number.isRequired,
  description: string,
  highlight: string,
  isMiniClass: bool,
  quota: number,
};

Token.defaultProps = {
  description: null,
  highlight: null,
  isMiniClass: false,
};

export default translate(['premium'])(Token);



// WEBPACK FOOTER //
// ./app/containers/Premium/components/Token/Token.jsx